// src/components/NavBar.js
import React from 'react';
import { IdCard, Map, MapPin, Users, Vote, Handshake, Calendar, BookOpen } from 'lucide-react';
import './NavBar.css';

const tabs = [
  { id: 'lookup',     label: 'Voter Lookup',   Icon: IdCard },
  { id: 'maps',       label: 'District maps',  Icon: Map },
  { id: 'wheretovote', label: 'Where to Vote', Icon: MapPin },
  { id: 'candidates', label: 'Candidates',     Icon: Users },
  { id: 'ballot', label: 'Ballot Initiatives', Icon: Vote },
  { id: 'volunteer',  label: 'Volunteer',      Icon: Handshake },
  { id: 'events',     label: 'Events',         Icon: Calendar },
  { id: 'resources',  label: 'Resources',      Icon: BookOpen },
];


const NavBar = ({ activeTab, setActiveTab }) => {
  return (
    <nav className="navbar" role="navigation" aria-label="Main navigation">
      {tabs.map(tab => (
        <button
          key={tab.id}
          className={`nav-btn ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => setActiveTab(tab.id)}
          aria-current={activeTab === tab.id ? 'page' : undefined}
        >
          <span className="nav-icon" aria-hidden="true">
            <tab.Icon size={16} color="currentColor" style={{ verticalAlign: 'middle' }} />
          </span>
          <span className="nav-label">{tab.label}</span>
        </button>
      ))}
    </nav>
  );
};

export default NavBar;
